import requestManager from '../platformApi/requestManager'
import appHelper from "@util/appHelper";

export default {

    /**
     * @param   {Object}    data
     * @param   {String}    data.bizId
     * @param   {Number}    data.bizType
     * @param   {Function}  callback
     */
    getVideoAd: function (data, callback) {
        return requestManager.request({
            url: 'portal/advertis/getVideoAd',
            data : data
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        });
    }

};
